import { render, staticRenderFns } from "./vip_setting.vue?vue&type=template&id=19361efe&"
import script from "./vip_setting.vue?vue&type=script&lang=ts&"
export * from "./vip_setting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports